import SessionStorage from './session-storage';


let instance;

export default class CsrfToken {
    constructor() {
        if (!instance) {
            instance = this;
            instance.sessionStorage = new SessionStorage();
            instance.headerName = CsrfToken.DEFAULT_HEADER_NAME;
            instance.storageKey = CsrfToken.STORAGE_KEY;
            instance.ajaxSendHandlerRegistered = false;
        }

        return instance;
    }

    init() {
        const tokenFromInitialState = this._readFromInitialState();
        const tokenFromStorage = this.getToken();

        const token = tokenFromInitialState || tokenFromStorage;

        if (token) {
            this.setToken(token);
        }

        return this.getToken();
    }

    registerAjaxSendHandler() {
        if (this.ajaxSendHandlerRegistered) {
            return;
        }

        $(document).ajaxSend((event, jqXHR) => {
            this.applyToRequest(jqXHR);
        });

        this.ajaxSendHandlerRegistered = true;
    }

    setToken(token) {
        const normalizedToken = this._normalizeToken(token);

        if (!normalizedToken) {
            return '';
        }

        const currentToken = this.getToken();

        if (currentToken === normalizedToken) {
            return currentToken;
        }

        this.sessionStorage.setItem(this.storageKey, normalizedToken);
        $(document).trigger(CsrfToken.UPDATED, { token: normalizedToken });

        return normalizedToken;
    }

    getToken() {
        return this.sessionStorage.getItem(this.storageKey) || '';
    }

    updateFromAjax(request) {
        return this.updateFromResponse(request);
    }

    updateFromResponse(jqXHR) {
        if (!jqXHR || typeof jqXHR.getResponseHeader !== 'function') {
            return '';
        }

        const headerNames = [
            this.headerName,
            'X-CSRF-Token',
            'x-csrf-token',
            'X-CSRF-TOKEN',
            'X-Csrf-Token'
        ];

        let tokenFromHeader = '';

        for (const headerName of headerNames) {
            const token = this._normalizeToken(jqXHR.getResponseHeader(headerName));

            if (token) {
                tokenFromHeader = token;
                break;
            }
        }

        return this.setToken(tokenFromHeader);
    }

    applyToRequest(jqXHR) {
        const token = this.getToken();

        if (!token || !jqXHR || typeof jqXHR.setRequestHeader !== 'function') {
            return;
        }

        jqXHR.setRequestHeader(this.headerName, token);
    }

    applyToForm(form) {
        const token = this.getToken();

        if (!token) {
            return;
        }

        const formElement = (form && form.jquery) ? form[0] : form;

        if (!formElement || typeof formElement.appendChild !== 'function') {
            return;
        }

        if (!this._isSameOriginRequest(formElement.action || '')) {
            return;
        }

        let existing = formElement.querySelector('input[name="' + CsrfToken.FIELD_NAME + '"]');

        if (existing) {
            existing.value = token;
        } else {
            let input = document.createElement('input');
            input.type = 'hidden';
            input.name = CsrfToken.FIELD_NAME;
            input.value = token;
            formElement.appendChild(input);
        }
    }

    _readFromInitialState() {
        if (typeof window === 'undefined' || !window.__INITIAL_STATE__) {
            return '';
        }

        const initialState = window.__INITIAL_STATE__;

        if (typeof initialState !== 'object' || initialState === null) {
            return '';
        }

        const token = this._normalizeToken(initialState.csrfToken);

        return token || '';
    }

    _isSameOriginRequest(requestUrl) {
        if (typeof window === 'undefined' || !window.location) {
            return false;
        }

        if (!requestUrl) {
            return true;
        }

        try {
            const resolvedUrl = new URL(requestUrl, window.location.href);

            return resolvedUrl.origin === window.location.origin;
        } catch (error) {
            return true;
        }
    }

    _normalizeToken(token) {
        return typeof token === 'string' ? token.trim() : '';
    }

    static get DEFAULT_HEADER_NAME() {
        return 'X-CSRF-Token';
    }

    static get FIELD_NAME() {
        return '_csrf';
    }

    static get STORAGE_KEY() {
        return 'CSRF_TOKEN';
    }

    static get UPDATED() {
        return 'CSRF_TOKEN__UPDATED';
    }
}
